/**
 * 成绩v2.2.1接口地址：http://rap2.10niu.cn/repository/editor?id=52&mod=667&itf=4350
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const resultManagement = {
	/**
	 *
	 * 获取考试列表
	 */
	getTestList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/exam_list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 添加考试
	 */
	addTest(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v1/add_exam`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 获取科目列表
	 */
	getSubjectList() {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/exam_subject`,
			headers: config.headers
		});
	},
	/**
	 * 获取考试详情
	 */
	getTestDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/exam_detail`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取年级班级列表
	 */
	getGradeClass(params) {
		return requestByGateway({
			method: 'get',
			url: `${
				config.api.admin
			}/SchoolStruct/Class/get_grade_class_list_by_schoolid`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 编辑考试
	 */
	editTest(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v1/edit_exam`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 发布详情
	 */
	releaseDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/exam_detail`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 发布考试
	 */
	releaseTest(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v1/publish_exam`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 *  删除考试
	 */
	deleteTest(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v1/remove_exam`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 成绩汇总
	 */
	getTestCollect(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/exam_student_summary`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 成绩详情
	 */
	getResultDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/exam_student_score`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 成绩详情(新)
	 */
	getResultDetailNew(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v2/get_examination_student_score`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 导入成绩
	 */
	importResult(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v1/import_student_score`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 导入成绩（新）
	 */
	importResultInName(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v2/import_student_score`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 学生成绩编辑
	 */
	editExamination(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v2/edit_examination_student_score`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 导出学生
	 */
	exportStudent(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/export_student_score`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 后台_成绩_科目_列表
	 */
	getAchievementList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v2/subject-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 后台_成绩_科目_添加
	 */
	subjectAdd(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v2/subject-add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 后台_成绩_科目_修改
	 */
	subjectUpdate(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v2/subject-update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 后台_成绩_科目_删除
	 */
	subjectDel(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.workneapi}/console/v2/subject-del`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};
export default resultManagement;
